<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <div class="lr between">
          <div style="display: flex;justify-content: space-between;">
            <el-input v-model="table.query.keyWord" placeholder="请输入关键字查询" clearable
                      suffix-icon="el-icon-search" @change="search(true)"/>
          </div>
          <div style="display: flex;justify-content: flex-end;">
            <el-button type="primary" size="small" @click="openDialog(null, false)"
                       icon="el-icon-plus">新增
            </el-button>
          </div>
        </div>
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="600px" border
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="组名" align="center"
                             prop="name"></el-table-column>
            <el-table-column show-overflow-tooltip label="成员" align="center"
                             prop="userNames"></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="210" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="openDialog(scope.row, true)">编辑</el-button>
                <el-button type="text" style="color: #ff4949;" @click="deleteData(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="lr end" style="margin-top: 20px;">
          <el-pagination :total="table.total" :page-size="table.query.size" :current-page="table.query.page"
                         layout="total, prev, pager, next" @current-change="currentPageChange"/>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="groupDialog.visible" :close-on-click-modal="false" width="40%"
               :title="!isEdit ? '新增组' : '编辑组'">
      <el-form ref="groupForm" label-position="right" label-width="120px" :model="groupDialog.formData"
               :rules="rules">
        <el-form-item label="名称：" prop="name">
          <el-input placeholder="请输入名称" v-model="groupDialog.formData.name" clearable/>
        </el-form-item>
        <el-form-item label="组员：" prop="userIds">
          <el-select filterable  v-model="groupDialog.formData.userIds" placeholder="请选择组员" multiple clearable style="width: 100%;">
            <el-option v-for="item in sales" :key="item.id" :value="item.id"
                       :label="item.nickname"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="groupDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="saveOrUpdateData" :loading="loading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import {getPageList, deleteData, saveOrUpdateData} from "@/api/userGroup";
import {getList} from "@/api/user";

export default {
  data() {
    return {
      table: {
        query: {
          page: 1,
          size: 10,
          keyWord: ''
        },
        total: 0,
        data: []
      },
      groupDialog: {
        formData: {
          name: '',
          userIds: '',
          userNames: ''
        },
        visible: false
      },
      rules: {
        name: [
          {trigger: 'change', required: true, message: '请输入组名'}
        ],
        userIds: [
          {trigger: 'change', required: true, message: '请选择组员'}
        ]
      },
      loading: false,
      tableLoading: false,
      isEdit: false,
      sales: []
    }
  },
  mounted() {
    this.search(true)
    this.getSales()
  },
  methods: {
    getSales() {
      const params = {
        roleId: '3'
      }
      getList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.sales = response.data
        }
      })
    },
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      if (flag) {
        this.table.query.page = 1
        this.table.query.size = 10
        this.table.query.keyWord = ''
      }
      const params = {
        current: this.table.query.page,
        size: this.table.query.size,
        keyWord: this.table.query.keyWord,
      }
      getPageList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 修改
    saveOrUpdateData() {
      this.loading = true
      this.$refs['groupForm'].validate(async (valid) => {
        if (valid) {
          const sales = this.sales.filter(item => this.groupDialog.formData.userIds.indexOf(item.id) != -1)
          this.groupDialog.formData.userIds = this.groupDialog.formData.userIds.join(',')
          this.groupDialog.formData.userNames = sales.map(item => item.nickname).join(',')
          saveOrUpdateData(this.groupDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.groupDialog.visible = false
              this.search(false)
            } else {
              // 操作失败
              this.$message.error('操作失败!')
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    // 打开弹窗
    openDialog(data, isEdit) {
      this.isEdit = isEdit
      if (!isEdit) {
        // 重置数据
        this.groupDialog.formData = {
          name: '',
          userIds: '',
          userNames: ''
        }
      } else {
        this.groupDialog.formData = JSON.parse(JSON.stringify(data))
        if (this.groupDialog.formData.userIds) {
          const userIds = this.groupDialog.formData.userIds.split(',')
          this.groupDialog.formData.userIds = []
          for (const userId of userIds) {
            this.groupDialog.formData.userIds.push(parseInt(userId))
          }
        }
      }
      this.groupDialog.visible = true
      // 清空验证信息
      this.$nextTick(() => {
        this.$refs.groupForm.clearValidate()
      })
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    // 删除
    deleteData(id) {
      this.$confirm('此操作将永久删除组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteData(id).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.search(false)
          } else {
            // 操作失败
            this.$message.error(response.data)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/system/userGroup.vue